import type { TourStep } from '@/components/ui/Tour';
import { PLAY_EVENT_SERIES_CREATE_TOUR_STEP_IDS } from '../tour-constants';
import { TourStepContent } from './StepContent';

/** New play series drawer — weekly social template and auto-generation. */
export const playEventSeriesCreateTourSteps: TourStep[] = [
  {
    content: (
      <TourStepContent
        title="Create a play series"
        description="Build a weekly social-rotate template. CourtSync publishes sessions automatically for the schedule period you choose."
      />
    ),
    selectorId: PLAY_EVENT_SERIES_CREATE_TOUR_STEP_IDS.DRAWER,
    position: 'left',
  },
  {
    content: (
      <TourStepContent
        title="Weekly schedule"
        description="Name the series, pick the weekday and start time, and choose singles or doubles (and mixed when applicable)."
      />
    ),
    selectorId: PLAY_EVENT_SERIES_CREATE_TOUR_STEP_IDS.SCHEDULE,
    position: 'bottom',
  },
  {
    content: (
      <TourStepContent
        title="Social pairing"
        description="Choose social mode, how odd player counts are handled, and the pairing priorities used when generating rounds."
      />
    ),
    selectorId: PLAY_EVENT_SERIES_CREATE_TOUR_STEP_IDS.SOCIAL,
    position: 'bottom',
  },
  {
    content: (
      <TourStepContent
        title="Rounds per session"
        description="Set how many rounds run each week and how long each round and break lasts. Session duration is calculated from these values."
      />
    ),
    selectorId: PLAY_EVENT_SERIES_CREATE_TOUR_STEP_IDS.ROUNDS,
    position: 'top',
  },
  {
    content: (
      <TourStepContent
        title="Registration rules"
        description="Control who can join, whether payment is collected online or at the door, and any gender restriction."
      />
    ),
    selectorId: PLAY_EVENT_SERIES_CREATE_TOUR_STEP_IDS.REGISTRATION,
    position: 'top',
  },
  {
    content: (
      <TourStepContent
        title="Courts"
        description="Pick the courts reserved for every generated session in this series."
      />
    ),
    selectorId: PLAY_EVENT_SERIES_CREATE_TOUR_STEP_IDS.COURTS,
    position: 'top',
  },
  {
    content: (
      <TourStepContent
        title="Auto-generation and listing"
        description="Choose how far ahead sessions are created, and optionally feature the series or enable kiosk registration for drop-ins."
      />
    ),
    selectorId: PLAY_EVENT_SERIES_CREATE_TOUR_STEP_IDS.GENERATION,
    position: 'top',
  },
  {
    content: (
      <TourStepContent
        title="Create series"
        description="Save the template. Published events for the selected period appear shortly — extend or deactivate the series later from the Series tab."
      />
    ),
    selectorId: PLAY_EVENT_SERIES_CREATE_TOUR_STEP_IDS.SUBMIT,
    position: 'top',
  },
];
